module.exports = __webpack_public_path__ + "static/media/image13-example.091ec885.jpg";